import { ComponentType } from 'react';
import { Navigate } from 'react-router';
import { getUser } from '../../app-context/accounts-context';
import { PAGES } from '../../model/constants';

//: FunctionComponent<Partial<RenderedRouteProps<P>>>
export function withAuth<P extends object>(Component: ComponentType<P>): ComponentType<P> {
    function ComponentWithAuthentication(props: Partial<P>) {
        const user = getUser();
        if (!user) {
            return (<Navigate to={PAGES.LOGIN} replace={true} />);
        }

        return (<Component {...props as P} />)
    }

    return ComponentWithAuthentication;
}